
<div ref="rfpRatingsCarousel" class="rfp-ratings-carousel">
  <div class="rfp-ratings-carousel-wrapper">
    <div
      class="rfp-ratings-carousel-inner"
      :style="`
        transform: translateX(${currentOffset}px);
        transition: ${transitionStyle};
        flex-basis: ${slideWidth}px;
        visibility: ${slideWidth ? 'visible' : 'hidden'}`"
    >
      <slot></slot>
    </div>
    <rfp-ratings-pagination v-if="paginationEnabled && pageCount > 0"> </rfp-ratings-pagination>
  </div>
  <rfp-ratings-navigation
    v-if="navigationEnabled"
    @navigate-next="advancePage('next')"
    @navigate-prev="advancePage('prev')"
    :click-target-size="navigationClickTargetSize"
  ></rfp-ratings-navigation>
</div>
